import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';

var EmptyHint =
/** @class */
function (_super) {
  __extends(EmptyHint, _super);

  function EmptyHint() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    type: String,
    "default": '暂无数据'
  })], EmptyHint.prototype, "hint", void 0);

  EmptyHint = __decorate([Component({
    name: 'EmptyHint'
  })], EmptyHint);
  return EmptyHint;
}(Vue);

export default EmptyHint;